import type React from 'react';
import GalleryCardTabComponent from 'src/Administration/PageContent/PageContentLibrary/LibraryGrid/GalleryCardTab/GalleryCardTab';
import InfoPopupTabComponent from 'src/Administration/PageContent/PageContentLibrary/LibraryGrid/InfoPopupTab/InfoPopupTab';
import MainCardTabComponent from 'src/Administration/PageContent/PageContentLibrary/LibraryGrid/MainCardTab/MainCardTab';
import ShowMetadataTabComponent from 'src/Administration/PageContent/PageContentLibrary/LibraryGrid/ShowMetadataTab/ShowMetadataTab';
import PreviewTabs from 'src/components/Tabs/PreviewTabs/PreviewTabs';
import TabPane from 'src/components/Tabs/TabPane/TabPane';
import styles from './LibraryGridStyles';

const LibraryGridComponent: React.FC = () => {
  const classes = styles();
  return (
    <div className={classes.tabWrapper}>
      <PreviewTabs>
        <TabPane name="Main Card" key="1">
          <MainCardTabComponent />
        </TabPane>
        <TabPane name="Show Metadata" key="2">
          <ShowMetadataTabComponent />
        </TabPane>
        <TabPane name="Info Popup" key="3">
          <InfoPopupTabComponent />
        </TabPane>
        <TabPane name="Gallery Card" key="4">
          <GalleryCardTabComponent />
        </TabPane>
      </PreviewTabs>
    </div>
  );
};

export default LibraryGridComponent;
